import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/body-surface-area-calculator',
  component: () => import('../../routes/BodySurfaceArea.svelte'),
  card: {
    id: 'body-surface-area',
    title: 'Body Surface Area (BSA)',
    description: 'Calculate your body surface area using five clinically validated formulas. Used for drug dosing, kidney function, and burn assessment.',
    icon: 'medical_information',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/body-surface-area-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Body Surface Area (BSA) Calculator – 5 Clinical Formulas',
    description: 'Free BSA calculator using DuBois, Mosteller, Haycock, Gehan & George, and Boyd formulas. Calculate body surface area in m² and ft² for drug dosing and medical assessments.',
  },
};

export default meta;